import Colors from './colors';
import Fonts from './fonts';
import LineHeights from './lineHeights';
import FontWeights from './fontWeights';
import ChatButton from './chatButton';

export default {
  Colors,
  Fonts,
  LineHeights,
  FontWeights,
  ChatButton
};
